import React from "react";
import { Link } from "react-router-dom";
import SEO from "../../components/SEO";
import { ChatrouletteAlternativeBanner } from "./Banners";
import FAQSection from "../../components/FAQSection";
import "./landing.css";

export default function ChatrouletteAlternative() {
  return (
    <>
      <SEO
        title="Best Chatroulette Alternative - Talkvee (Bot-Free & Safe)"
        description="Looking for a modern Chatroulette alternative? Talkvee is a fast, bot-free random video chat with built-in games like Trivia and Tic-Tac-Toe."
        pathname="/chatroulette-alternative"
        jsonLd={{
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://talkvee.com" },
            { "@type": "ListItem", "position": 2, "name": "Chatroulette Alternative", "item": "https://talkvee.com/chatroulette-alternative" }
          ]
        }}
      />

      <div className="landing-wrapper">
        <ChatrouletteAlternativeBanner />
        
        <section className="landing-hero">
          <h1 className="landing-title">The Modern Chatroulette Alternative</h1>
          <p className="landing-subtitle">
            Tired of bots and outdated websites? Talkvee is the next generation of random video chat. 
            Connect instantly in a heavily moderated, ad-free environment with built-in icebreaker games.
          </p>
          <Link to="/" className="tv-cta">🚀 Start Chatting on Talkvee</Link>
        </section>

        <section className="comparison-section" style={{maxWidth: '800px', margin: '40px auto', padding: '0 15px'}}>
          <h3 style={{textAlign: 'center', marginBottom: '20px', color: 'var(--tv-text)'}}>Talkvee vs. Chatroulette</h3>
          <div style={{display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '20px', textAlign: 'left'}}>
            <div style={{background: '#fee2e2', padding: '20px', borderRadius: '12px', border: '1px solid #fecaca'}}>
              <h4 style={{margin: '0 0 10px', color: '#b91c1c', fontSize: '1.1rem'}}>❌ Chatroulette</h4>
              <ul style={{paddingLeft: '20px', margin: 0, color: '#7f1d1d', lineHeight: '1.6'}}>
                <li>Frequent Bots & Spam</li>
                <li>Basic Video Only</li>
                <li>Outdated Interface</li>
              </ul>
            </div>
            <div style={{background: '#dcfce7', padding: '20px', borderRadius: '12px', border: '1px solid #bbf7d0'}}>
              <h4 style={{margin: '0 0 10px', color: '#15803d', fontSize: '1.1rem'}}>✅ Talkvee</h4>
              <ul style={{paddingLeft: '20px', margin: 0, color: '#14532d', lineHeight: '1.6'}}>
                <li>Strict Human Moderation</li>
                <li>Interactive Games (Trivia)</li>
                <li>Fast, Mobile-Friendly Design</li>
              </ul>
            </div>
          </div>
        </section>

        <FAQSection
          items={[
            {
              q: "Why is Talkvee a better alternative to Chatroulette?",
              a: "Talkvee eliminates the massive bot problem found on older sites. We also provide built-in games like Trivia to help break the ice and make conversations actually fun."
            },
            {
              q: "Is Talkvee free to use?",
              a: "Yes, 100% free with no hidden subscriptions or intrusive pop-up ads."
            },
            {
              q: "Do I need to download anything?",
              a: "No! Talkvee runs smoothly right in your mobile or desktop browser without any extra plugins."
            }
          ]}
        />
      </div>
    </>
  );
}